import { render, staticRenderFns } from "./GraphEditorUiGuideRemoveNodesPage.vue?vue&type=template&id=4ed77adb"
import script from "./GraphEditorUiGuideRemoveNodesPage.vue?vue&type=script&lang=js"
export * from "./GraphEditorUiGuideRemoveNodesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports